// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMMENT_DELETED_BY_ADMIN = "Odpov\u011b\u010f byla odstran\u011bn\u00e1";
export const COMMENT_DELETED_BY_AUTHOR = "Autor odpov\u011b\u010f smazal";
export const SHOW = "Zobraz";
